module.exports = __webpack_public_path__ + "img/37-min.c195885a.jpg";